import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { breakpoints, MaxWidthStyled, mq } from '@hangar31/rc-layout';
import toColor from '@OnArk/utils/toColor';
export const NavLinkStyled = styled.a<{
  parent?: string;
  ['data-active']?: boolean;
}>(
  ({ theme }) => theme.font(),
  ({ theme }) => css`
    display: block;
    margin: 0 1rem;
    padding: 0.8rem 1.5rem;

    color: ${theme.colors.white};
    font-weight: bold;
    line-height: 1em;

    border-top: 6px solid transparent;

    border-bottom: 6px solid transparent;
    @media (hover: hover) {
      &:hover {
        color: ${theme.colors.white};

        border-bottom-color: ${theme.colors.secondary};
      }
    }

    &[data-active='true'],
    &[data-parent='true'] {
      color: ${theme.colors.secondary} !important;
      &:hover {
        color: ${theme.colors.secondary};

        border-bottom-color: transparent !important;
      }
    }
  `
);

export const NavButtonStyled = styled.a(
  ({ theme }) => theme.font('md', 'bl'),
  ({ theme }) => css`
    display: block;
    margin-left: 1rem;
    padding: 0.8rem 3rem;

    color: ${theme.colors.white};
    font-size: 1.8rem;

    background-color: ${toColor(theme.colors.white, 0.15)};
    border: 2px solid ${toColor(theme.colors.white, 0.5)};
    border-radius: 3rem;

    &:hover {
      color: ${theme.colors.white};

      background-color: ${toColor(theme.colors.white, 0.25)};
    }
  `
);

export const WebsiteNavStyled = styled(MaxWidthStyled)<{
  open: boolean;
}>(
  ({ theme }) => css`
    > div {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    margin-bottom: 2rem;
    padding-bottom: 2rem;
    a,
    button {
      color: ${theme.colors.white};
    }
  `,
  () =>
    mq({
      fontSize: ['1.4rem', undefined, undefined, undefined, '2rem', '2.4rem'],

      paddingTop: ['2rem'],
    }),

  mq({
    '> div': { display: ['none', undefined, undefined, undefined, 'flex'] },
  }),
  ({ open, theme }) =>
    open &&
    css`
      @media (max-width: ${breakpoints.lg}px) {
        a,
        button {
          color: ${theme.colors.clickable};

          pointer-events: all;
        }
        > div:first-of-type {
          position: fixed;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          z-index: 200000;

          display: flex;
          flex-direction: column;
          align-items: stretch;
          width: 100%;
          padding-top: 8rem;

          background: ${theme.colors.white};
        }

        > div:nth-of-type(2) {
          position: fixed;
          bottom: 6rem;
          z-index: 200001;

          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          align-items: stretch;
          button {
            color: ${theme.colors.white};

            background: ${theme.colors.clickable};
          }
        }
      }
    `
);
